export default __webpack_public_path__ + "static/media/suliac-lounge2-min.7e92b346.jpg";